var _path, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconUiCheckmark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "icon-ui--checkmark_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h20v20H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-ui--checkmark_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.817 11.788L6.881 9.852a.605.605 0 00-.435-.177.59.59 0 00-.443.177.598.598 0 00-.181.44c0 .171.06.318.18.438l2.288 2.287c.15.15.326.226.527.226.2 0 .377-.075.527-.226l4.636-4.636a.605.605 0 00.178-.435.59.59 0 00-.178-.443.598.598 0 00-.439-.181.598.598 0 00-.439.18l-4.285 4.286zm1.184 6.128a7.712 7.712 0 01-3.088-.623A7.995 7.995 0 014.4 15.601a7.994 7.994 0 01-1.692-2.513 7.705 7.705 0 01-.624-3.087c0-1.095.208-2.124.623-3.088A7.996 7.996 0 014.398 4.4a7.995 7.995 0 012.513-1.692 7.705 7.705 0 013.087-.624c1.095 0 2.125.208 3.088.623.963.416 1.801.98 2.514 1.692a7.995 7.995 0 011.693 2.513c.416.963.623 1.992.623 3.087a7.711 7.711 0 01-.623 3.088 7.994 7.994 0 01-1.692 2.514 7.994 7.994 0 01-2.513 1.693 7.705 7.705 0 01-3.087.623zM10 16.666c1.86 0 3.437-.646 4.729-1.937 1.291-1.292 1.937-2.868 1.937-4.73 0-1.86-.646-3.437-1.937-4.728-1.292-1.292-2.868-1.938-4.73-1.938-1.86 0-3.437.646-4.728 1.938C3.979 6.562 3.333 8.139 3.333 10c0 1.86.646 3.437 1.938 4.729C6.562 16.02 8.139 16.666 10 16.666z",
    fill: "#1C1B1F"
  }))));
}

export default __webpack_public_path__ + "media/images/styleguide/icons/icon-ui--checkmark-dc977f4bcf9ab6c7316484567fcb03a9.svg";
export { SvgIconUiCheckmark as Component };